import { Fragment } from "react";
import StaedteError from "./Error";

export default function BarsDetails( params ) {

    const barsDetails = params.data;

    let errorOccured = undefined !== barsDetails.errors;
    if ( errorOccured ) {
        // TODO: How to handle missing detail data?
        return(
            <Fragment>
                <StaedteError />
            </Fragment>
        );
    } else if ( undefined === barsDetails || 0 === barsDetails.length ) {
        window.location = `${window.location.protocol}//${window.location.hostname}/404`;
        return;
    }

    var rowNo = 0;

    return(
        
        <div className="d-flex flex-column">

            <div className="table-responsive">
            
                <table className="table staedte-bars-details-table">
                    <thead>
                        <tr>
                            <th><div className="p-2">{window.staedteFrontendShortcodeData.i18n.number}</div></th>
                            <th><div className="p-2 text-nowrap">{window.staedteFrontendShortcodeData.i18n.location}</div></th>
                            <th><div className="p-2 text-nowrap">{window.staedteFrontendShortcodeData.i18n.address}</div></th>
                            <th><div className="p-2 text-nowrap">{window.staedteFrontendShortcodeData.i18n.opensAt}</div></th>
                            <th><div className="p-2 text-nowrap">{window.staedteFrontendShortcodeData.i18n.closesAt}</div></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            barsDetails.map(
                                (barDetails, index) => {

                                    const isEndLocation = 1 === Number( barDetails.isEndLocation );
                                    const isStartLocation = 1 === Number( barDetails.isStartLocation );

                                    rowNo += 1;

                                    return(
                                        <tr key={index}>
                                            <td>
                                                <div className="m-2">
                                                    {rowNo}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="m-2 text-nowrap">
                                                    {barDetails.location}
                                                    {
                                                        isStartLocation ? 
                                                        <span title="Startlocation" className="dashicons dashicons-bank ms-2"></span> : ''
                                                    }
                                                    {
                                                        isEndLocation ? 
                                                        <span title="Endlocation" className="dashicons dashicons-welcome-learn-more ms-2"></span> : ''
                                                    }
                                                </div>
                                            </td>
                                            <td>
                                                <div className="m-2 text-nowrap">
                                                    {barDetails.address}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="m-2 text-nowrap">
                                                    {
                                                        ( (!barDetails.opensAt) || 0 === barDetails.opensAt.length ) ?
                                                            '-' : (`${barDetails.opensAt} ${window.staedteFrontendShortcodeData.i18n.clock}`)
                                                    }
                                                </div>
                                            </td>
                                            <td>
                                                <div className="m-2 text-nowrap">
                                                    {
                                                        ( (!barDetails.closesAt) || 0 === barDetails.closesAt.length ) ?
                                                            '-' : (`${barDetails.closesAt} ${window.staedteFrontendShortcodeData.i18n.clock}`)
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                            )
                        }
                    </tbody>
                </table>

            </div>


        </div>
    );

}